export const environment = {
  production: false,
  api: {
    baseUrl: '/api/'
  },
  passwordRegexp: '.{8,}'
};
